import React from 'react';

import { BORDER, cell, MONTH_H } from '../shared/style';

export default function MonthHeaderCell({ mg }) {
  return (
    <div
      style={cell({
        gridColumn: `span ${mg.count}`,
        background: '#fff',
        borderRight: BORDER,
        borderBottom: BORDER,
        padding: '4px 10px',
        fontSize: 12.5,
        fontWeight: 700,
        color: '#1a1a1a',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        height: MONTH_H,
        display: 'flex',
        alignItems: 'center',
      })}
    >
      {mg.label}
    </div>
  );
}
